import type { GameEventDraft, GameRuntime, GameState, PhaseNode } from './state';
import type { SeatIdx } from '../types';

// Phase transition helpers (plan §7). enterPhase is a plain node swap; the modules'
// onWindowOpen hooks fire ONLY through openWindow — called by genuine window-openers
// (END_TURN's rotation, setup completion, the paired partner hand-off), NEVER by
// interlude returns (a militia played pre-roll must not refresh the card allowance —
// outline §14.15; caught in H1-S7 review).

export function enterPhase(state: GameState, _env: GameRuntime, node: PhaseNode, _emit: (e: GameEventDraft) => void): void {
  state.phase = node;
}

/** A NEW action window opens for `seat`: fire the modules' hooks (plan §5.2). */
export function openWindow(state: GameState, env: GameRuntime, seat: SeatIdx): void {
  for (const { hook } of env.composed.windowOpen) hook(state, env, seat);
}

/** Next non-resigned seat clockwise from (from+1). Falls back to `from` if all others resigned. */
export function nextActiveSeat(state: GameState, from: SeatIdx): SeatIdx {
  const n = state.seats.length;
  for (let step = 1; step <= n; step++) {
    const seat = (from + step) % n;
    if (!state.seats[seat]!.resigned) return seat;
  }
  return from;
}
